/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmVlastnostObecnyObjekt extends GContentBase<SeznamAdmVlastnostObecnyObjektObj> {
        private seznamObj: SeznamAdmVlastnostObecnyObjektObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmVlastnostObecnyObjektObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmVlastnostObecnyObjektNew",
                contentCaption: "jres:33000418", //RC 33000418 : Nav�zan� vlastnosti na z�znam
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_txt} - {ico}"
                },
                gridSettings: {
                    columnOrder: "typ_vps_txt,ixs_txt,poradi,ico_txt,dat_zmena,zmenu_provedl"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmVlastnostObecnyObjektObj extends GAdmSeznamBase {
        private typ_obj: number;
        private ico: string;
        private nazev: string;
        private sxs: string;

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmVlastnostObecnyObjekt", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmVlastnostObecnyObjekt",
                newRecord: isNew,
                nazev: this.nazev,
                sxs: isNew == true ? ((this.sxs) ? this.sxs : null) : data.sxs,
                typ_obj: isNew == true ? ((this.typ_obj) ? this.typ_obj : null) : data.typ_obj,
                ixs: isNew == true ? null : data.ixs,
                ico: isNew == true ? ((this.ico) ? this.ico : null) : data.ico,
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:33000413").addField("gstringbox", { //RC 33000413 : Objekt
                name: "nazev",
                disabled: this.nazev ? true : false
            }).addRow("jres:29929518").addField("gselectbox", Gordic.Prefabs.Select.admGincobj(), {
                name: "typ_obj",
                model: "model.typ_obj=value.typ_obj",
                disabled: this.typ_obj ? true : false,
                dropdown: true
            })/*.addRow("jres:32131046").addField("gselectbox", Gordic.Prefabs.Select.ekosico(), {
                name: "ico",
                model: "model.ico=value.ico",
                disabled: this.ico ? true : false,
                dropdown: true
            })*/
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.typ_obj)
                hardFilter["typ_obj"] = this.typ_obj
            if (this.ico)
                hardFilter["ico"] = this.ico
            if (this.nazev)
                hardFilter["nazev"] = this.nazev
            return hardFilter;
        }

        collectData(data: any) {
            delete data["nazev"];
            if (this.sxs)
                data["sxs"] = this.sxs
            if (this.ico)
                data["ico"] = this.ico
            if (this.typ_obj)
                data["typ_obj"] = this.typ_obj
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmVlastnostObecnyObjekt.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}#{3}#".format(data.sxs, data.ixs, data.typ_obj, data.ico),
                nazev: ""
            }
        }
    }
}